import { IThunkDispatch, RootState } from "../store";
import { ICtc } from "../interfaces/CtcInterface";
import { EmployeeInterface } from "../containers/ResourceCentre/UserSettings/AllUsers";

export enum Type {
  PUT_RESOURCECENTREEMPLOYEE = "PUT_RESOURCECENTREEMPLOYEE"
}

// Update employee's activeCtc in state.resources
export const updateEmployeeWithCtc =
  (employeeId: number, ctcData: ICtc | null) =>
  async (dispatch: IThunkDispatch, getState: () => RootState): Promise<void> => {
    const state = getState();

    const employee = state.resources.resourceCentreEmployees.find(
      (emp: EmployeeInterface) => emp.id === employeeId
    );

    if (!employee) return;

    const updatedEmployee = { ...employee, activeCtc: ctcData };

    dispatch({
      type: Type.PUT_RESOURCECENTREEMPLOYEE,
      payload: updatedEmployee
    });
  };
